import {
    type MetaFunction,
    type LoaderFunctionArgs,
    redirect,
  } from '@remix-run/node'
  import { Calendar, Users, DollarSign } from 'lucide-react'
import HowItWorksSection from '#app/components/howItWorks.tsx'
  import Testimonials from '#app/components/testimonials.tsx'
  import { getUserId } from '#app/utils/auth.server.ts'
  import Contact from '../../components/contact'
  import { Hero } from '../../components/hero'
  import { Pricing } from '../../components/pricing'
  import { PrimaryFeatures } from '../../components/primary-features'
  import { TwoColumn } from '../../components/two-column'
  
  export const meta: MetaFunction = () => {
    return [
      { title: "OuiChef | Restaurant Scheduling Software | Staff Management Made Easy" },
      { name: "description", content: "OuiChef's restaurant scheduling software streamlines staff management, tracks labor costs, and eliminates spreadsheets. Get real-time insights for better budget control." },
      { name: "keywords", content: "restaurant scheduling software, staff scheduling, restaurant management, labor cost tracking, restaurant staff management" },
      { property: "og:title", content: "OuiChef | Restaurant Scheduling Software" },
      { property: "og:description", content: "Streamline restaurant staff scheduling, track availability, and monitor labor costs in real-time with OuiChef." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://ouichef.com" },
    //   { property: "og:image", content: "https://ouichef.com/img/og-image.jpg" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "OuiChef | Restaurant Scheduling Software" },
      { name: "twitter:description", content: "Streamline restaurant staff scheduling and monitor labor costs in real-time." },
    //   { name: "twitter:image", content: "https://ouichef.com/img/twitter-image.jpg" },
      { name: "robots", content: "index, follow" },
      { name: "canonical", content: "https://ouichef.com" },
    ]
  }
  
  export const loader = async ({ request }: LoaderFunctionArgs) => {
    const user = await getUserId(request)
    if (user) {
      return redirect('/recipes')
    }
    return {}
  }
  
  export default function Index() {
    const schedulingFeatures = [
      {
        id: 'schedule', // This ID will be used as the tab value
        title: 'Staff Scheduling',
        description:
          'Create efficient weekly schedules in minutes based on staff availability. Our restaurant scheduling software makes it easy to assign shifts and keep your team organized.',
        icon: Calendar,
      },
      {
        id: 'staff',
        title: 'Staff Management',
        description:
          'Manage your restaurant staff profiles, track availability preferences, and maintain a clear overview of your entire team. Keep everyone on the same page with our intuitive scheduling system.',
        icon: Users,
      },
      {
        id: 'costs',
        title: 'Labor Costs',
        description:
          'Monitor your daily and weekly labor costs in real-time. Our restaurant scheduling software helps you stay on budget by showing exactly how staffing decisions impact your bottom line.',
        icon: DollarSign,
      },
    ]
  
    return (
      <>
        <Hero
          titleFirstLine="Restaurant Staff Scheduling Made Easy"
          titleSecondLine="Control Labor Costs & Save Time"
          description="OuiChef's restaurant scheduling software eliminates spreadsheets, tracks staff availability, and gives you real-time labor cost insights for better budget control."
          featureOne="Create weekly schedules based on staff availability in minutes"
          featureTwo="Monitor daily and weekly wage costs in real-time"
          featureThree="Set shift templates and customize actual working hours"
          primaryButtonText="Start Free Trial"
          primaryButtonLink="/signup"
          secondaryButtonText=""
          secondaryButtonLink=""
          heroImage="/img/back.jpg"
          imageAlt="Chef managing restaurant schedule on tablet"
        />
          <HowItWorksSection url={"https://www.loom.com/embed/8d04dd1f4dd8407998b1f807c4c909ec?sid=00519f13-6ea8-4237-860a-8ce4bae9349e"} />
    
        <Pricing />
        {/* <Testimonials /> */}
        {/* <TwoColumn /> */}
        <Contact />
      </>
    )
  }